import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext();

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkSession();
  }, []);

  const checkSession = async () => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const response = await axios.get(`${API}/auth/session`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setUser(response.data.user);
        setProfile(response.data.profile);
      } catch (error) {
        localStorage.removeItem('token');
      }
    }
    setLoading(false);
  };

  const login = async (email, password, mfa_code = null) => {
    const payload = { email, password };
    if (mfa_code) payload.mfa_code = mfa_code;
    const response = await axios.post(`${API}/auth/login`, payload);
    if (response.data.mfa_required) {
      return response.data;
    }
    localStorage.setItem('token', response.data.token);
    setUser(response.data.user);
    await checkSession();
    return response.data;
  };

  // After an invite is accepted the server hands back a session token.
  const signInWithToken = async (token, nextUser) => {
    localStorage.setItem('token', token);
    setUser(nextUser);
    await checkSession();
  };

  const logout = () => {
    localStorage.removeItem('token');
    setUser(null);
    setProfile(null);
  };

  return (
    <AuthContext.Provider value={{ user, profile, loading, login, signInWithToken, logout }}>
      {!loading && children}
    </AuthContext.Provider>
  );
};